import { inject, Injectable } from '@angular/core';
import { map } from 'rxjs';
import { AppConfigService } from '../app-config.service';

@Injectable({ providedIn: 'root' })
export class CRMAccessService {
  private readonly appConfigService = inject(AppConfigService);

  readonly canViewAllCampaigns$ = this.appConfigService.config$.pipe(
    map((config) => config.isSuperAdmin || (config.userIsAdmin && config.userCanAccessMarketing)),
  );

  readonly canModifyAutomations$ = this.appConfigService.config$.pipe(
    map((config) => config.isSuperAdmin || (config.userIsAdmin && config.userCanAccessAutomations)),
  );
}
